import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { KeycloakService } from 'keycloak-angular';
import { ImpersonationService } from 'src/app/services/impersonation/impersonation.service';

@Component({
  selector: 'app-impersonation-bar',
  standalone: true,
  imports: [CommonModule, TranslateModule, TooltipModule],
  templateUrl: './impersonation-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonationBarComponent {

  private readonly keycloakService = inject(KeycloakService);
  readonly impersonationService = inject(ImpersonationService);

  readonly state$ = this.impersonationService.state$;

  logout(): void {
    this.keycloakService.logout();
  }
}
